import React from "react";
import type { RuntimeImageProps } from "@apa/core-renderers";
import { getStoragePublicBaseUrl } from "./Constant";

const isAbsoluteSrc = (value: string) =>
	/^https?:\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:");

export const normalizeStorageKey = (value?: string | null): string => {
	const trimmed = (value ?? "").toString().trim();
	if (!trimmed) return "";
	const base = getStoragePublicBaseUrl().trim().replace(/\/+$/, "");
	if (base && trimmed.startsWith(base)) {
		return trimmed.slice(base.length).replace(/^\/+/, "");
	}
	if (isAbsoluteSrc(trimmed)) {
		return trimmed;
	}
	return trimmed.replace(/^\/+/, "");
};

export const resolveStorageUrl = (src?: string | null): string => {
	const trimmed = (src ?? "").toString().trim();
	if (!trimmed) return "";
	if (isAbsoluteSrc(trimmed)) return trimmed;
	const base = getStoragePublicBaseUrl().trim();
	// Paths starting with / are treated as storage-relative when a base URL is set
	if (trimmed.startsWith("/") && base) {
		return `${base.replace(/\/+$/, "")}${trimmed}`;
	}
	if (trimmed.startsWith("/")) return trimmed;
	if (!base) {
		return `/${trimmed}`;
	}
	return `${base.replace(/\/+$/, "")}/${trimmed.replace(/^\/+/, "")}`;
};

export const createRuntimeImageComponent = () => {
	return ({ src, fill: _fill, priority: _priority, children: _children, ...rest }: RuntimeImageProps) => {
		const resolvedSrc = resolveStorageUrl(src);
		// `rest` carries the SDK's RuntimeImageProps (a superset of <img> attrs whose `style`
		// CSSProperties varies by the resolved csstype version); assert to the DOM img attrs so the
		// spread stays valid across dependency bumps.
		return <img {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)} src={resolvedSrc} />;
	};
};
